module.exports = __webpack_public_path__ + "img/single-line.2d374160.svg";